module.exports = __webpack_public_path__ + "static/media/arrow-up.1cfef956.svg";